"use client";

import { SignInButton, SignUpButton } from "@clerk/nextjs";
import { Button } from "@/components/ui/button";

export function MarketingActions() {
  return (
    <div className="flex items-center gap-2">
      <SignInButton>
        <Button variant="ghost">Sign in</Button>
      </SignInButton>
      <SignUpButton>
        <Button variant="brand">Get started</Button>
      </SignUpButton>
    </div>
  );
}

export function MarketingSignIn() {
  return (
    <SignInButton>
      <Button size="lg" variant="brand">
        Sign in to your workspace
      </Button>
    </SignInButton>
  );
}
